import { z } from 'zod';

/**
 * Zod schemas for owner statement-related entities
 * These provide runtime validation and type inference
 */

// OwnerStatement schema - using passthrough to allow extra fields for PDF generation
export const ownerStatementSchema = z.object({
  id: z.string(),
  ownerId: z.string(),
  period: z.string().min(1, 'Period is required'),
  ownerName: z.string().min(1, 'Owner name is required'),
  propertyName: z.string().min(1, 'Property name is required'),
  propertyId: z.string().optional(),
  netIncome: z.number(),
  revenue: z.number().nonnegative(),
  expenses: z.number().nonnegative().optional(),
  status: z.string(),
  generatedDate: z.string(),
}).passthrough(); // Allow extra fields for PDF generation compatibility

export type OwnerStatement = z.infer<typeof ownerStatementSchema>;
